// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"465":"7f17d93e","565":"e0577bb8","848":"df68d388"}[chunkId] + ".css";
};